import type React from 'react';

import { Wrapper } from './wrapper';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  small?: boolean;
  textDarkLighten?: boolean;
  fullWidth?: boolean;
};

const Content = ({
  children,
  small,
  textDarkLighten,
  fullWidth,
  dangerouslySetInnerHTML,
}: Props) => (
  <Wrapper
    $small={small}
    $textDarkLighten={textDarkLighten}
    $fullWidth={fullWidth}
    dangerouslySetInnerHTML={dangerouslySetInnerHTML}
  >
    {children}
  </Wrapper>
);

export default Content;
